import { createContext } from 'react';
import type { TriageRun } from 'src/graphql/entities/conversation-triage-run';

export interface TriageRunContextValue {
  runs: TriageRun[];
  isLoading: boolean;
  error: Error | undefined;
  isResolving: (actionId: string) => boolean;
  accept: (actionId: string) => Promise<void>;
  dismiss: (actionId: string) => Promise<void>;
  retry: (actionId: string) => Promise<void>;
}

export const TriageRunContext = createContext<TriageRunContextValue | null>(null);
